// Available naming element types - will be filtered based on packager config
export const ALL_NAMING_ELEMENT_TYPES = [
  { value: 'STRING_LITERAL', label: 'String Literal' },
  { value: 'METADATA', label: 'Metadata' },
  { value: 'DOCUMENT_DATA', label: 'Document Data' },
  { value: 'SPLIT_VALUE', label: 'Split Value' },
];

// Valid date format patterns
export const VALID_DATE_FORMATS = [
  { value: '%Y', label: '%Y - 4-digit year (2025)' },
  { value: '%m', label: '%m - Month as zero-padded decimal (01-12)' },
  { value: '%d', label: '%d - Day as zero-padded decimal (01-31)' },
  { value: '%H', label: '%H - Hour (24-hour) as zero-padded decimal (00-23)' },
  { value: '%M', label: '%M - Minute as zero-padded decimal (00-59)' },
  { value: '%S', label: '%S - Second as zero-padded decimal (00-59)' },
  { value: '%B', label: '%B - Full month name (January, February, etc.)' },
  { value: '%b', label: '%b - Abbreviated month name (Jan, Feb, etc.)' },
];

// Function to validate date format
export const validateDateFormat = (format: string): boolean => {
  if (!format) return true; // Empty format is valid
  const validPatterns = VALID_DATE_FORMATS.map((f) => f.value);
  const formatParts = format.match(/%[YmdHMSBb]/g) || [];
  return formatParts.every((part) => validPatterns.includes(part));
};

// Function to generate format preview
export const generateFormatPreview = (format: string): string => {
  if (!format) return 'No format specified';

  try {
    const now = new Date();
    let preview = format;

    // Replace format patterns with actual values
    preview = preview.replace(/%Y/g, now.getFullYear().toString());
    preview = preview.replace(/%m/g, String(now.getMonth() + 1).padStart(2, '0'));
    preview = preview.replace(/%d/g, String(now.getDate()).padStart(2, '0'));
    preview = preview.replace(/%H/g, String(now.getHours()).padStart(2, '0'));
    preview = preview.replace(/%M/g, String(now.getMinutes()).padStart(2, '0'));
    preview = preview.replace(/%S/g, String(now.getSeconds()).padStart(2, '0'));

    const monthNames = [
      'January',
      'February',
      'March',
      'April',
      'May',
      'June',
      'July',
      'August',
      'September',
      'October',
      'November',
      'December',
    ];
    const monthAbbr = [
      'Jan',
      'Feb',
      'Mar',
      'Apr',
      'May',
      'Jun',
      'Jul',
      'Aug',
      'Sep',
      'Oct',
      'Nov',
      'Dec',
    ];

    preview = preview.replace(/%B/g, monthNames[now.getMonth()]);
    preview = preview.replace(/%b/g, monthAbbr[now.getMonth()]);

    return preview;
  } catch (error) {
    return 'Invalid format';
  }
};
